import { VirtualTableHeadCell } from '../../virtualized-table/types';

export const headCells: VirtualTableHeadCell[] = [
  {
    width: 300,
    accessor: 'command',
    Header: 'Command',
  },
  {
    width: 100,
    accessor: 'modifiedDateTime',
    Header: 'Last Modified',
  },
  {
    width: 100,
    accessor: 'modifiedBy',
    Header: 'Modified By',
  },
];

export const headCellsAccessors = {
  modifiedDateTime: true,
};
